<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.typeSelection_id" class="modal-card-title">Crear Tipo de Pregunta</p>
          <p v-else class="modal-card-title">Editar Tipo de Pregunta</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="typeSelection.name"
              v-model="typeSelection.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.typeSelection_id" class="button is-primary" @click="createTypeSelection()">Guardar</button>
          <button v-else class="button is-primary" @click="editTypeSelection()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeTypeSelectionList",
    "typeSelection_id",
  ],
  data() {
    return {
      typeSelection: {
        name: "",
      },
      isLoading: false,
    };
  },
  created: function () {
    this.isLoading = true;
    if (this.typeSelection_id) {
      this.chargeStablishmentData().then(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    createTypeSelection: async function () {
      this.isLoading = true;
      let data = {
        ...this.typeSelection,
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/type_selection`, data).then(
        (response) => {
          //Limpia el objeto stablishment
          for (const i in this.typeSelection) {
            this.typeSelection[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeTypeSelectionList();
          this.closeBasic();
          this.toast("Creado el Tipo de Pregunta", "is-success");
          this.isLoading = false;
        },
        (response) => {
          this.toast("Error al crear", "is-danger");
          this.isLoading = false;
          console.log("error: ", response);
        }
      );
    },
    editTypeSelection: function () {
      this.isLoading = true;
      let data = {
        ...this.typeSelection,
      };
      this.$http
        .put(`api/${localStorage.getItem('perfil')}/type_selection/` + this.typeSelection_id, data)
        .then(
          (response) => {
            //Limpia el objeto prevition
            for (const i in this.typeSelection) {
              this.typeSelection[i] = "";
            }
            console.log("PUT:", response.body);
            this.chargeTypeSelectionList();
            this.closeBasic();
            this.toast("Editado el tipo de pregunta", "is-success");
            this.isLoading = false;
          },
          (response) => {
            this.toast("Error al editar", "is-danger");
            this.isLoading = false;
            console.log("error: ", response);
          }
        );
    },
    chargeStablishmentData: async function () {
      await this.$http
        .get(`api/${localStorage.getItem('perfil')}/type_Selection/` + this.typeSelection_id)
        .then(
          (response) => {
            this.typeSelection.name = response.body.typeSelection.name;
          },
          (response) => {
            console.log(response);
          }
        );
    },
  },
};
</script>